import React, { useState, useContext } from "react";
import styled from "styled-components";
import ProjectList from "../../components/ProjectList/ProjectList.tsx";
import prosData from "../../datas/prosData";
import codesData from "../../datas/codesData";
import gamesData from "../../datas/gamesData";
import { Titre, SousTitre } from "../../utils/style/elements.tsx";
import Nav from "../../components/Nav/Nav.jsx";
import NavMobile from "../../components/NavMobile/NavMobile.jsx";
import colors from "../../utils/style/colors.tsx";
import { LanguageContext } from "../../context/LanguageContext";
import accueilTrad from "../../traductions/accueil-trad.js";

const Main = styled.div`
    display: flex;
    flex-direction: row;
`;

const PageContent = styled.div`
    width: ${(props) => (props.$isCollapsed ? "92%" : "80%")};
    margin-left: ${(props) => (props.$isCollapsed ? "160px" : "260px")};
    transition: all 0.3s ease;

    @media (max-width: 768px) {
        width: 100%;
        margin-left: 0;
    }
`;

const StyledTexte = styled(SousTitre)`
    color: ${colors.gray};
    text-align: center;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    font-weight: 400;

    @media (max-width: 768px) {
        width: 90%;
    }
`;

const ListeContainer = styled.div`
    margin-bottom: 50px;
`;

function Accueil() {
    const [isCollapsed, setIsCollapsed] = useState(false);

    const { language } = useContext(LanguageContext);

    return (
        <React.StrictMode>
            <StyledTexte>{accueilTrad[language].texte}</StyledTexte>

            <Main>
                <Nav onToggle={setIsCollapsed} />
                <NavMobile /> 
                <PageContent $isCollapsed={isCollapsed}>
                    <ListeContainer>
                        <Titre id="games">{accueilTrad[language].games}</Titre>
                        <ProjectList projects={gamesData} />
                    </ListeContainer>

                    <ListeContainer>
                        <Titre id="pros">{accueilTrad[language].pro}</Titre>
                        <ProjectList projects={prosData} />
                    </ListeContainer>
                    
                    <ListeContainer>
                        <Titre id="codes">{accueilTrad[language].code}</Titre>
                        <ProjectList projects={codesData} />
                    </ListeContainer>

                </PageContent>
            </Main>
        </React.StrictMode>
    );
}

export default Accueil;
